// @flow
import * as React from 'react';

import { Error, Errors } from './styles';

import { FormattedMessage } from 'react-intl';
import { identity } from 'lodash/fp';

type Props = {
    errors: Object,
    messages: Object
};

export default ({ errors, messages }: Props) => {
    const keys = Object.keys(errors);

    if (!keys.length) {
        return null;
    }

    const displayMessages = keys
        .map(key => {
            const message = messages[key];
            return (
                message && (
                    <Error key={key}>
                        <FormattedMessage {...message} />
                    </Error>
                )
            );
        })
        .filter(identity);

    if (!displayMessages.length) {
        return null;
    }

    return <Errors>{displayMessages}</Errors>;
};



// WEBPACK FOOTER //
// ./src/components/widgets/errors/index.js